class InforM3Controller extends AbstractIntegrationController
	@register()
	@inject '$filter',
		'$scope'
		'$uibModal'
		'configuration'
		'configurationOptions'
		'units'
		'vatRates'
		'shops'
		'IntegrationRepository'
		'ProductRepository'
		'ToastService'
		'Guid'
		'BACKEND_TRANSACTION_PAYMENT_TYPE'
		'BACKEND_TRANSACTION_CARD_TYPE'
		'parseBool'

	integrationId: 'infor_m3'

	initialize: ->
		@showRunAction = false
		@isNew = !@parseBool(@configuration.is_active)

		@updating = !@isNew
		@additionalButtonsTemplate = '@app/integration/infor-m3/infor-m3.additional-buttons.view.html'

		@tabs = [
			{
				title: 'general.details'
				selector: '#tab-details'
				form: 'vm.mainForm.details'
			}
			{
				title: 'general.shops'
				selector: '#tab-shops'
				form: 'vm.mainForm.shops'
			}
			{
				title: 'wbo.integration.infor_m3.payment_types'
				selector: '#tab-payments'
				form: 'vm.mainForm.paymentTypes'
			}
			{
				title: 'wbo.integration.infor_m3.vat_codes'
				selector: '#tab-vat-codes'
				form: 'vm.mainForm.vatCodes'
			}
			{
				title: 'wbo.integration.infor_m3.units_of_measure'
				selector: '#tab-units-of-measure'
				form: 'vm.mainForm.unitsOfMeasure'
			}
			{
				title: 'wbo.integration.infor_m3.product_relations'
				selector: '#tab-product-relations'
				form: 'vm.mainForm.productRelations'
			}
		]

		# Watch $invalid state of each tab's form
		@$scope.$watchGroup(
			@tabs.map((tab) => tab.form + '.$invalid'),
			(values) =>
				for value, index in values
					@tabs[index].error = value
		)

		if @isNew
			@resetConfiguration()

		@initializeEmptySets()
		@initializeProductRelations()

	initializeEmptySets: ->
		for key in ['shops', 'payment_types', 'card_types', 'vat_codes', 'units_of_measure']
			if _.isEmpty(@configuration[key])
				@configuration[key] = {}

		if _.isEmpty(@configuration.product_relations)
			@configuration.product_relations = []

	initializeProductRelations: ->
		if _.isEmpty @configuration.product_relations
			return

		productIds = []

		for relation in @configuration.product_relations
			productIds.push(relation.parent_id, relation.child_id)

		productIds = _.uniq(productIds)

		query = @ProductRepository.createQuery()
		query
			.withoutAnyRelations()
			.criteria 'id', 'IN', productIds.join()

		@ProductRepository
			.getEntities(query)
			.then (products) =>
				products = _.indexBy(products, 'id')

				for relation in @configuration.product_relations
					relation.id = @Guid.generate()
					relation.parent_name = products[relation.parent_id]?.name ? "#{relation.parent_id} (Deleted)"
					relation.child_name = products[relation.child_id]?.name ? "#{relation.child_id} (Deleted)"

	save: ->
		delete @configuration.tender_declaration_id

		for type in ['card_types', 'payment_types', 'units_of_measure', 'vat_codes']
			for key, config of @configuration[type]
				if _.isEmpty(config)
					delete @configuration[type][key]

		for relation in @configuration.product_relations
			relation.coefficient = parseFloat(relation.coefficient)

		super(@configuration)
			.then (response) =>
				@configuration = response.data
				@isNew = false

				@initializeProductRelations()

	afterDisconnect: ->
		@resetConfiguration()
		@initializeEmptySets()

	resetConfiguration: ->
		@configuration =
			port: 22
			tender_declaration_id: 0

	runIntegration: (timestampFrom, timestampTo, timeZone, shopId = null) ->
		requestBody =
			from: timestampFrom
			to: timestampTo
			time_zone: timeZone
			shop_id: shopId || null

		@saving = true
		@IntegrationRepository
			.customPost @integrationId, 'run', requestBody
			.then =>
				# This may lead to fake impression that integration has actually started processing, even through we
				# get only response about dispatched event
				@configurationOptions.last_synchronization = 0
				@configuration.tender_declaration_id++
				@ToastService.add(
					@$filter('translate')('wbo.integrations.run.in_progress').toString(),
					@$filter('translate')('wbo.integrations.run.integration')
					@integrationId
					'success'
				)
			.finally =>
				@saving = false

	getPercentageLabelText: (value) ->
		if value?
			return '(' + (value * 100).toFixed(2) + ' %)'

		return value

	showResendModal: ->
		@$uibModal.open
			templateUrl: '@app/integration/infor-m3/modals/infor-m3.resend.modal.view.html'
			bindToController: true
			controllerAs: 'resendModal'
			controller: ($uibModalInstance, resend, shops) ->
				$onInit: ->
					@shopId = null
					@resend = resend
					@shops = shops
					@$uibModalInstance = $uibModalInstance
					@datePicker =
						maxDate: moment()

				onClick: ->
					@resend(@datePicker.startDate, @datePicker.endDate, moment.tz.guess(), @shopId)
					@$uibModalInstance.close(true)
			resolve:
				shops: => @shops
				resend: =>
					(timestampFrom, timestampTo, timeZone, shopId) =>
						@runIntegration(timestampFrom, timestampTo, timeZone, shopId)

	addProductRelation: ->
		@mainForm.productRelations.$setDirty()
		@configuration.product_relations.push({
			id: @Guid.generate()
			parent_id: null
			child_id: null
			coefficient: 50
		})

	removeProductRelation: (relation) ->
		@mainForm.productRelations.$setDirty()
		@configuration.product_relations = _.reject @configuration.product_relations, {id: relation.id}
